const STORAGE_KEY = "mexfba_app_version";

interface AppVersionResponse {
    version?: string;
}

export async function checkForAppUpdate(): Promise<boolean> {
    try {
        const response = await fetch(
            `${process.env.PUBLIC_URL || ""}` +
                `/version.json?t=${Date.now()}`,
            {
                cache: "no-store"
            }
        );

        if (!response.ok) {
            return false;
        }

        const data =
            await response.json() as AppVersionResponse;

        const remoteVersion = String(
            data.version || ""
        ).trim();

        if (!remoteVersion) {
            return false;
        }

        const installedVersion = localStorage.getItem(
            STORAGE_KEY
        );

        /*
            Primera carga de la PWA:
            se guarda la versión actual y no se muestra alerta.
        */
        if (!installedVersion) {
            localStorage.setItem(
                STORAGE_KEY,
                remoteVersion
            );

            return false;
        }

        return installedVersion !== remoteVersion;
    } catch (error) {
        console.warn(
            "No fue posible verificar una actualización:",
            error
        );

        return false;
    }
}

export function clearSavedAppVersion(): void {
    localStorage.removeItem(STORAGE_KEY);
}
